import { useCustomerKey } from "./useCustomerKey";
import { CUSTOMERS_WITH_PRODUCING_COUNTDOWN_TIMER } from "constants/customers";
import { PnlCategoriesEnum } from "types/enums";
import { ONE_SECOND_OF_MS } from "utils/timeUtils";
import { useSelector } from "store/useSelector";

export const useCountdownTimer = (
  pnlCategory: PnlCategoriesEnum | string, // (sometimes "loading" from getCallAndLastSegmentDetails)
  processId: string
): { showCountdown: boolean; countDownFromMs: number | null } => {
  const ckey = useCustomerKey();
  const isCountdownCustomer =
    CUSTOMERS_WITH_PRODUCING_COUNTDOWN_TIMER.includes(ckey);

  // show countdown timer only in the producing state
  const isProducing = pnlCategory === PnlCategoriesEnum.producing;
  const showCountdown = isProducing && isCountdownCustomer;

  // time to count down from comes from Midgard skuTarget
  const dataDump = useSelector(
    state => state.legacy.dataDumpsFullRangeByProcess[processId]
  );

  const countDownFromMs =
    dataDump?.lastSegment?.targetRate || dataDump?.lastSegment?.targetRate === 0
      ? dataDump.lastSegment.targetRate * ONE_SECOND_OF_MS
      : null;
  return { showCountdown, countDownFromMs };
};
